export const getTripDurationDays = (startDateStr, endDateStr) => {
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return (end - start) / (1000 * 60 * 60 * 24) + 1;
  };
  
  export const getSuggestedCancellationDate = (startDateStr, endDateStr) => {
    if (!startDateStr || !endDateStr) return null;
  
    const duration = getTripDurationDays(startDateStr, endDateStr);
    const cancelDate = new Date(startDateStr);
  
    if (duration > 6) {
      cancelDate.setDate(cancelDate.getDate() - 20);
    } else if (duration >= 2) {
      cancelDate.setDate(cancelDate.getDate() - 7);
    } else {
      cancelDate.setDate(cancelDate.getDate() - 2);
    }
  
    cancelDate.setHours(0, 0, 0, 0);
    return cancelDate;
  };
  
  export const getSuggestedCancellationInfoText = (startDateStr, endDateStr) => {
    const suggested = getSuggestedCancellationDate(startDateStr, endDateStr);
    if (!suggested) return null;
  
    const formatted = suggested.toLocaleDateString("pl-PL");
    return `Sugerowana data: ${formatted}\n\n` +
      `Termin do którego wycieczka może być odwołana ze względu na niewystarczającą liczbę zgłoszeń:\n\n` +
      `a) 20 dni przed rozpoczęciem imprezy turystycznej trwającej ponad 6 dni,\n\n` +
      `b) 7 dni przed rozpoczęciem imprezy turystycznej trwającej 2–6 dni,\n\n` +
      `c) 2 dni przed rozpoczęciem imprezy turystycznej trwającej krócej niż 2 dni.`;
  };
  